import { graphql } from '@/lib/query'
import ImageFragment from '../image'
import LinkFragment from '../link'

const TeaserCardFragment = graphql(
  /* GraphQL */ `
    fragment TeaserCardFragment on TeaserCardRecord @_unmask {
      title
      text
      link {
        ...LinkFragment
      }
      image {
        ...ImageFragment
      }
    }
  `,
  [ImageFragment, LinkFragment]
)

export default TeaserCardFragment
